import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Helpers } from "src/helpers/helpers";
import { BaseService } from "./base.service";
import { ICountService } from "./icount.service";
import { CareplusPolicy } from "src/models/careplus-policy";
import { RateCard } from "src/models/rate-card";

@Injectable({
  providedIn: "root",
})
export class CareplusOrdersService
  extends BaseService
  implements ICountService
{
  private pathAPI = environment.apiUrl;

  constructor(
    private http: HttpClient,
    helper: Helpers,
  ) {
    super(helper);
  }

  getData(body: any): Observable<CareplusPolicy[]> {
    return this.http.post<CareplusPolicy[]>(
      this.pathAPI + "careplus/policy/requests?isOrder=true",
      body,
      super.header(),
    );
  }

  getCount(body: any) {
    return this.http
      .post<any>(
        this.pathAPI + "careplus/policy/requests/count?isOrder=true",
        body,
        super.header(),
      )
      .pipe(catchError(super.handleError));
  }

  getOrderById(id: string): Observable<Partial<RateCard>> {
    return this.http
      .get(this.pathAPI + "careplus/policy/requests/" + id, super.header())
      .pipe(catchError(super.handleError));
  }
}
